'use client';

import IconText2 from '@/components/elements/icon/icon-text2';
import { useTranslation } from '@/i18n/client';
import { EventDetails } from '@/types/events';
import { WithLang } from '@/types/general';
import { getEventDates } from '@/utils/date-utils';

export default function EventDate(props: WithLang<{ event: EventDetails }>) {
    const { t } = useTranslation(props.lang, 'calendar');

    const { startDate, endDate } = getEventDates()(props.event.start_date, props.event.duration);
    const dateStrings = {
        dateString: t('formats.dayMonthYearWeekday', {
            day: startDate.date(),
            month: startDate.month(),
            year: startDate.year(),
            weekday: startDate.day(),
        }),
        time:
            `${startDate.hour()}:${startDate.minute().toString().padStart(2, '0')} – ` +
            `${endDate.hour()}:${endDate.minute().toString().padStart(2, '0')}`,
    };

    return (
        <>
            {dateStrings.dateString && <IconText2 icon="phi-calendar-16" text={dateStrings.dateString} sizeMd={5} />}
            {dateStrings.time && <IconText2 icon="phi-clock-16" text={dateStrings.time} sizeMd={5} />}
        </>
    );
}
